/* =========================================================
   Cery Shop - Spesa Rapida mobile con scanner EAN/SKU.
   ========================================================= */
(() => {
  if (window.__ceryQuickShop) return;
  window.__ceryQuickShop = true;

  const ZXING_SRC = 'https://cdn.jsdelivr.net/npm/@zxing/browser@0.1.5/umd/zxing-browser.min.js';
  const BARCODE_FORMATS = ['ean_13', 'ean_8', 'upc_a', 'upc_e', 'code_128', 'code_39'];
  const productCache = new Map();
  const items = new Map();
  const pendingCodes = new Set();

  let indexPromise = null;
  let dialog;
  let video;
  let statusEl;
  let listEl;
  let emptyEl;
  let addButton;
  let codeInput;
  let totalEl;
  let stream = null;
  let detector = null;
  let rafId = null;
  let zxingReader = null;
  let zxingPromise = null;
  let running = false;
  let lastCode = '';
  let lastTime = 0;

  function setupFloatingActionsAutoHide() {
    const body = document.body;
    if (!body) return;

    let revealTimer = null;
    let ticking = false;

    const reveal = () => {
      body.classList.remove('cery-floating-actions--hidden');
      revealTimer = null;
    };

    const hideWhileScrolling = () => {
      body.classList.add('cery-floating-actions--hidden');
      clearTimeout(revealTimer);
      revealTimer = setTimeout(reveal, 340);
    };

    window.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          hideWhileScrolling();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', reveal, { passive: true });
  }

  setupFloatingActionsAutoHide();

  const normalizeCode = (value) => String(value || '').trim().replace(/[^0-9A-Za-z]/g, '').toUpperCase();

  function codeCandidates(value) {
    const code = normalizeCode(value);
    if (!code) return [];

    const candidates = [];
    const push = (candidate) => {
      const normalized = normalizeCode(candidate);
      if (normalized && !candidates.includes(normalized)) candidates.push(normalized);
    };

    push(code);

    if (/^\d+$/.test(code)) {
      if (code.length === 12) push(`0${code}`);
      if (code.length === 13 && code.startsWith('0')) push(code.slice(1));

      const withoutLeadingZeroes = code.replace(/^0+/, '');
      if (withoutLeadingZeroes && withoutLeadingZeroes !== code) push(withoutLeadingZeroes);
    }

    return candidates;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function money(cents) {
    if (typeof cents !== 'number') return '';
    return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function route(path) {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  }

  function setStatus(message, type = '') {
    if (!statusEl) return;
    statusEl.textContent = message || '';
    statusEl.dataset.type = type;
  }

  function getEls() {
    dialog = document.querySelector('[data-cery-quick-shop-dialog]');
    if (!dialog) return false;
    video = dialog.querySelector('[data-cery-quick-shop-video]');
    statusEl = dialog.querySelector('[data-cery-quick-shop-status]');
    listEl = dialog.querySelector('[data-cery-quick-shop-list]');
    emptyEl = dialog.querySelector('[data-cery-quick-shop-empty]');
    addButton = dialog.querySelector('[data-cery-quick-shop-add]');
    codeInput = dialog.querySelector('[data-cery-quick-shop-code]');
    totalEl = dialog.querySelector('[data-cery-quick-shop-total]');
    return true;
  }

  function render() {
    if (!listEl || !emptyEl || !addButton) return;
    const rows = Array.from(items.values());
    const total = rows.reduce((sum, item) => {
      return sum + (typeof item.price === 'number' ? item.price * item.quantity : 0);
    }, 0);

    emptyEl.hidden = rows.length > 0;
    addButton.disabled = rows.length === 0 || rows.every((item) => !item.available);
    addButton.textContent = rows.length > 0 ? `Aggiungi al carrello (${rows.reduce((sum, item) => sum + item.quantity, 0)})` : 'Aggiungi al carrello';

    if (totalEl) {
      totalEl.hidden = rows.length === 0;
      const totalValue = totalEl.querySelector('[data-cery-quick-shop-total-value]');
      if (totalValue) totalValue.textContent = money(total);
    }

    listEl.innerHTML = rows
      .map((item) => {
        const image = item.image
          ? `<img class="cery-quick-shop__item-img" src="${escapeHtml(item.image)}" alt="" loading="lazy">`
          : '<span class="cery-quick-shop__item-img cery-quick-shop__item-img--empty"></span>';
        const availability = item.available ? '' : '<span class="cery-quick-shop__item-warn">Non disponibile</span>';
        const lineTotal = typeof item.price === 'number' ? item.price * item.quantity : null;
        const price = lineTotal === null ? '' : `<span class="cery-quick-shop__item-price">${item.quantity > 1 ? `${money(item.price)} cad. &middot; ${money(lineTotal)}` : money(item.price)}</span>`;

        return (
          `<li class="cery-quick-shop__item" data-variant-id="${item.variantId}">` +
          image +
          '<div class="cery-quick-shop__item-main">' +
          `<span class="cery-quick-shop__item-title">${escapeHtml(item.title)}</span>` +
          `<span class="cery-quick-shop__item-code">${escapeHtml(item.code)} ${availability}</span>` +
          price +
          '</div>' +
          '<div class="cery-quick-shop__qty">' +
          `<button type="button" data-cery-quick-shop-qty="-1" data-variant-id="${item.variantId}" aria-label="Diminuisci">-</button>` +
          `<span>${item.quantity}</span>` +
          `<button type="button" data-cery-quick-shop-qty="1" data-variant-id="${item.variantId}" aria-label="Aumenta">+</button>` +
          '</div>' +
          `<button type="button" class="cery-quick-shop__remove" data-cery-quick-shop-remove data-variant-id="${item.variantId}" aria-label="Rimuovi">` +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round"><path d="m18 6-12 12"/><path d="m6 6 12 12"/></svg>' +
          '</button>' +
          '</li>'
        );
      })
      .join('');
  }

  function openDialog() {
    if (!getEls()) return;
    if (!dialog.open) dialog.showModal();
    setStatus('Inquadra un EAN/SKU.');
    render();
    startScanner();
  }

  function closeDialog() {
    stopScanner();
    if (dialog?.open) dialog.close();
  }

  function loadIndex() {
    if (indexPromise) return indexPromise;
    indexPromise = fetch(window.CERY_INDEX_URL || route('/assets/cery-product-index.json'))
      .then((response) => {
        if (!response.ok) throw new Error('Indice prodotti non disponibile');
        return response.json();
      })
      .then((index) => ({
        bySku: index.bySku || {},
        byEan: index.byEan || {},
      }))
      .catch(() => ({ bySku: {}, byEan: {} }));
    return indexPromise;
  }

  function findIndexEntry(index, rawCode) {
    for (const code of codeCandidates(rawCode)) {
      const entry = index.bySku?.[code] || index.byEan?.[code];
      if (entry) return { ...entry, matchedCode: code };
    }

    return null;
  }

  function productHandle(product) {
    if (product?.handle) return product.handle;

    const url = product?.url || product?.online_store_url || '';
    const match = String(url).match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  async function suggestEntry(rawCode) {
    for (const code of codeCandidates(rawCode)) {
      const url = new URL(route('/search/suggest.json'), location.origin);
      url.searchParams.set('q', code);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '4');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set(
        'resources[options][fields]',
        'title,product_type,vendor,variants.title,variants.sku,variants.barcode'
      );

      const response = await fetch(url);
      if (!response.ok) continue;

      const data = await response.json();
      const products = data.resources?.results?.products || [];
      const product = products.find((item) => productHandle(item)) || null;
      const handle = productHandle(product);
      if (handle) return { h: handle, t: product.title || handle, matchedCode: code };
    }

    return null;
  }

  async function getProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    const request = fetch(route(`/products/${handle}.js`)).then((response) => {
      if (!response.ok) throw new Error('Prodotto non disponibile');
      return response.json();
    });

    productCache.set(handle, request);
    return request;
  }

  function findVariant(product, rawCode) {
    const variants = Array.isArray(product.variants) ? product.variants : [];
    const candidates = codeCandidates(rawCode);
    const exact = variants.find((variant) => {
      const sku = normalizeCode(variant.sku);
      const barcode = normalizeCode(variant.barcode);
      return candidates.includes(sku) || candidates.includes(barcode);
    });
    if (exact) return exact;

    return variants.find((variant) => variant.available) || variants[0] || null;
  }

  async function resolveCode(rawCode) {
    const code = normalizeCode(rawCode);
    if (!code) return null;

    const index = await loadIndex();
    let entry = findIndexEntry(index, code);
    if (!entry) entry = await suggestEntry(code);
    if (!entry?.h) return { code, missing: true };

    const product = await getProduct(entry.h);
    const variant = findVariant(product, entry.matchedCode || code);
    if (!variant?.id) return { code, missing: true };

    const image = variant.featured_image?.src || product.featured_image || product.images?.[0] || '';
    return {
      code,
      title: product.title || entry.t || code,
      variantTitle: variant.public_title || variant.title || '',
      variantId: String(variant.id),
      available: variant.available !== false,
      price: variant.price,
      image,
    };
  }

  async function addCode(rawCode) {
    const code = normalizeCode(rawCode);
    if (!code || pendingCodes.has(code)) return;

    pendingCodes.add(code);
    setStatus(`Cerco ${code}...`);

    try {
      const product = await resolveCode(code);
      if (!product || product.missing) {
        setStatus(`Codice non trovato: ${code}`, 'warn');
        return;
      }

      const existing = items.get(product.variantId);
      if (existing) {
        existing.quantity += 1;
      } else {
        items.set(product.variantId, { ...product, quantity: 1 });
      }

      if (navigator.vibrate) navigator.vibrate(35);
      setStatus(product.available ? `Aggiunto: ${product.title}` : `Non disponibile: ${product.title}`, product.available ? 'ok' : 'warn');
      render();
    } catch (error) {
      setStatus('Non riesco a leggere questo prodotto.', 'warn');
    } finally {
      pendingCodes.delete(code);
    }
  }

  function stopStream() {
    if (!stream) return;
    stream.getTracks().forEach((track) => track.stop());
    stream = null;
  }

  function stopNativeDetector() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    detector = null;
    stopStream();
    if (video) video.srcObject = null;
  }

  function stopScanner() {
    running = false;
    stopNativeDetector();
    if (zxingReader) {
      try {
        zxingReader.reset();
      } catch (error) {}
      zxingReader = null;
    }
  }

  function startScanner() {
    if (!video || running) return;
    running = true;
    lastCode = '';
    lastTime = 0;

    if ('BarcodeDetector' in window && navigator.mediaDevices?.getUserMedia) {
      startNativeDetector();
      return;
    }

    startZxing();
  }

  async function startNativeDetector() {
    try {
      const supportedFormats =
        typeof window.BarcodeDetector.getSupportedFormats === 'function'
          ? await window.BarcodeDetector.getSupportedFormats()
          : BARCODE_FORMATS;
      const formats = BARCODE_FORMATS.filter((format) => supportedFormats.includes(format));

      if (!formats.length) throw new Error('No supported barcode formats');

      detector = new window.BarcodeDetector({ formats });
      stream = await navigator.mediaDevices.getUserMedia({
        audio: false,
        video: {
          facingMode: { ideal: 'environment' },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        },
      });

      if (!running) {
        stopNativeDetector();
        return;
      }

      video.srcObject = stream;
      await video.play();
      setStatus('Scanner pronto.');
      scanNativeFrame();
    } catch (error) {
      stopNativeDetector();
      if (running) startZxing();
    }
  }

  async function scanNativeFrame() {
    if (!running || !detector || !video) return;

    try {
      if (video.readyState >= 2) {
        const barcodes = await detector.detect(video);
        const match = barcodes.find((barcode) => barcode?.rawValue);
        if (match) handleScan(match.rawValue);
      }
      rafId = requestAnimationFrame(scanNativeFrame);
    } catch (error) {
      stopNativeDetector();
      if (running) startZxing();
    }
  }

  function loadZxing() {
    if (window.ZXingBrowser) return Promise.resolve();
    if (zxingPromise) return zxingPromise;

    zxingPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector('script[data-cery-zxing]');
      if (existing) {
        existing.addEventListener('load', () => resolve(), { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = ZXING_SRC;
      script.async = true;
      script.defer = true;
      script.dataset.ceryZxing = 'true';
      script.onload = () => resolve();
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return zxingPromise;
  }

  function startZxing() {
    setStatus(window.ZXingBrowser ? 'Avvio fotocamera...' : 'Preparo scanner...');

    loadZxing()
      .then(() => {
        if (!running) return;
        zxingReader = new window.ZXingBrowser.BrowserMultiFormatReader(undefined, {
          delayBetweenScanAttempts: 90,
          delayBetweenScanSuccess: 350,
        });
        const decoding = zxingReader.decodeFromConstraints(
          {
            audio: false,
            video: {
              facingMode: { ideal: 'environment' },
              width: { ideal: 1280 },
              height: { ideal: 720 },
            },
          },
          video,
          (result) => {
            if (result && running) handleScan(result.getText());
          }
        );

        if (decoding && typeof decoding.catch === 'function') {
          decoding.catch(() => setStatus('Fotocamera non disponibile.', 'warn'));
        }

        setStatus('Scanner pronto.');
      })
      .catch(() => setStatus('Scanner non supportato.', 'warn'));
  }

  function handleScan(rawCode) {
    const code = normalizeCode(rawCode);
    if (!code) return;

    const now = Date.now();
    if (code === lastCode && now - lastTime < 1600) return;
    lastCode = code;
    lastTime = now;
    addCode(code);
  }

  async function addToCart() {
    const cartItems = Array.from(items.values())
      .filter((item) => item.available)
      .map((item) => ({ id: Number(item.variantId), quantity: item.quantity }));

    if (!cartItems.length) return;
    addButton.disabled = true;
    setStatus('Aggiungo al carrello...');

    try {
      const addResponse = await fetch(window.Theme?.routes?.cart_add_url || route('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems }),
      });

      if (!addResponse.ok) throw new Error('Cart add failed');

      const cartUrl = window.Theme?.routes?.cart_url || route('/cart');
      const cart = await fetch(`${cartUrl}.js`).then((response) => response.json());
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'cery-quick-shop',
            data: {
              source: 'cery-quick-shop',
              itemCount: cart.item_count,
            },
          },
        })
      );

      setStatus('Prodotti aggiunti al carrello.', 'ok');
      window.location.assign(cartUrl);
    } catch (error) {
      setStatus('Non sono riuscito ad aggiungere al carrello.', 'warn');
      render();
    }
  }

  function updateQuantity(variantId, delta) {
    const item = items.get(String(variantId));
    if (!item) return;
    item.quantity += delta;
    if (item.quantity <= 0) items.delete(String(variantId));
    render();
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('[data-cery-quick-shop-open]')) {
      event.preventDefault();
      openDialog();
      return;
    }

    if (target.closest('[data-cery-quick-shop-close]')) {
      event.preventDefault();
      closeDialog();
      return;
    }

    if (target.closest('[data-cery-quick-shop-add]')) {
      event.preventDefault();
      addToCart();
      return;
    }

    if (target.closest('[data-cery-quick-shop-clear]')) {
      event.preventDefault();
      items.clear();
      render();
      setStatus('Lista svuotata.');
      return;
    }

    const qtyButton = target.closest('[data-cery-quick-shop-qty]');
    if (qtyButton) {
      event.preventDefault();
      updateQuantity(qtyButton.dataset.variantId, Number(qtyButton.dataset.ceryQuickShopQty || 0));
      return;
    }

    const removeButton = target.closest('[data-cery-quick-shop-remove]');
    if (removeButton) {
      event.preventDefault();
      items.delete(String(removeButton.dataset.variantId));
      render();
    }
  });

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof Element ? event.target.closest('[data-cery-quick-shop-manual]') : null;
    if (!form) return;

    event.preventDefault();
    addCode(codeInput?.value || '');
    if (codeInput) codeInput.value = '';
  });

  document.addEventListener('cancel', (event) => {
    if (event.target === dialog) closeDialog();
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
})();
